import Rest from '@services/Rest';

/**
 * @typedef {createTicket}
 */
export default class createTicket extends Rest {
  /**
   * @type {String}
   */
  static resource = '/admin/create-ticket'
}
